import * as ActionTypes from "services/state/action-types";

const RESCHEDULING_INITIAL_STATE = {
  loading: false,
  error: false,
  data: null,
};

export function rescheduling(state = RESCHEDULING_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.SEND_RESCHEDULING:
      return { ...state, loading: true };

    case ActionTypes.SEND_RESCHEDULING_SUCCESS:
      return { ...state, loading: false };

    case ActionTypes.SEND_RESCHEDULING_FAIL:
      return { ...state, loading: false, error: true };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/state/rescheduling/reducer.js